// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { TYPE_LINKS_MAP } from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import {
  getDefaultQueryFilter,
  getDefaultValueFilter,
  getFileNameExcel,
  numberWithCommas,
} from "helpers/utils";
import { useGetFilter } from "hook";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import DetailInvoicePos from "pages/InvoicePos/DetailInvoicePos";
import { TYPE_INVOICE } from "pages/ReportInvoiceError/helper/functionHelper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import { exportInvoice, resetExportInvoice } from "store/actions";
import {
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import {
  getReportInvoiceList,
  resetDownloadReportInvoice,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailInvoice from "./DetailInvoice";
import { getInvoiceStatus } from "./helper/functionHelper";
import PDFViewModal from "./modal/PDFViewModal";
import {
  formatHiddenColumn,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "./utils";
const ListAdjust = props => {
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  const [dataDetail, setDataDetail] = useState({});

  const [detailModal, setDetailModal] = useState(false);
  const toggleDetailModal = () => {
    setDetailModal(!detailModal);
  };

  const [detailPosModal, setDetailPosModal] = useState(false);
  const toggleDetailPosModal = () => {
    setDetailPosModal(!detailPosModal);
  };

  const [mode, setMode] = useState("");
  const [pageView, setPageView] = useState(null);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { type, fileDownload, fileDownloadName } = summaryInvoiceData;
  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    exportInvoiceData,
    type: typeInvoice,
    fileDownload: fileDownloadInvoice,
    fileDownloadName: fileDownloadNameInvoice,
  } = issueInvoice;

  const history = useHistory();

  const { t, i18n } = useTranslation(["issueInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  const {
    isLoading: isLoadingDefaultFilter,
    isSuccess: isSuccessDefaultFilter,
    data: dataDefaultFilter,
    refetch: refetchDefaultFilter,
  } = useGetFilter(SCREEN_FILTER_CODE.INVOICE_ADJUST);

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [listData]);

  useEffect(() => {
    switch (typeInvoice) {
      case EXPORT_INVOICE_SUCCESS: {
        if (fileDownloadInvoice !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadInvoice;
          link.setAttribute("download", fileDownloadNameInvoice);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      default:
        break;
    }
  }, [typeInvoice]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  //   useEffect(() => {
  //     switch (type) {
  //       case RELEASE_INVOICE_CYCLES_SUCCESS:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thành công", {
  //           appearance: "success",
  //           autoDismiss: true,
  //         });
  //         toggleHSMSignModal();
  //         dispatch(getReportInvoiceList(params));
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //       case RELEASE_INVOICE_CYCLES_FAIL:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thất bại", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //     }
  //   }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buTenantHeaderInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo && isSuccessDefaultFilter) {
      params.page = 1;
      resetDataFunc(true);
    }
  }, [finalBuInfo, isSuccessDefaultFilter]);

  useEffect(() => {
    refetchDefaultFilter();
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  useEffect(() => {
    //
    if (isSuccessDefaultFilter) {
      initColumn(true);
    }
  }, [isSuccessDefaultFilter]);

  const initColumn = (loadDefaultFilter = false) => {
    const columns = getInitColumns(loadDefaultFilter);
    let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    setColumns(formatHiddenColumn(columnsVisibleInvoice, columns));
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail(row);
      //   toggleViewDetailModal();
    },
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: "Download file",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    // },
  ];

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách hóa đơn",
      isLoading: exportInvoiceData.loading,
      loadingText: "Đang xuất danh sách hóa đơn",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          "filter[type][in]": [
            TYPE_LINKS_MAP.TYPE_ADJUST_DECREMENT,
            TYPE_LINKS_MAP.TYPE_ADJUST_INCREMENT,
            TYPE_LINKS_MAP.TYPE_ADJUST_INFO,
            TYPE_LINKS_MAP.TYPE_ADJUST_TT32,
          ],
          sort: params.sort ? params.sort : "-checker_date",
          keywords: params.keywords,
        };
        dispatch(
          exportInvoice(
            objectExport,
            getFileNameExcel("DanhSachHoaDonDieuChinh"),
            "links/export"
          )
        );
      },
    },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columns
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "child_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "root_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "child_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "root_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          //   case "nmua_ten":
          //     objectExport[
          //       `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
          //     ] = true;
          //     objectExport[
          //       `columns[${formatData.dataField}][dimensionOptions][width]`
          //     ] = 80;
          //     break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            if (formatData.dataField?.includes("child")) {
              objectExport[
                `columns[${formatData.dataField}][headerOptions][fill][startColor][argb]`
              ] = "d7e3bb";
            } else if (formatData.dataField?.includes("root")) {
              objectExport[
                `columns[${formatData.dataField}][headerOptions][fill][startColor][argb]`
              ] = "ffff00";
            }
            break;
        }
        //
        const value =
          formatData.text +
          ` (HĐ ${key.indexOf("child") > -1 ? "điều chỉnh" : "bị điều chỉnh"})`;
        objectExport[key] = value;

        return formatData;
      });
    let finalObjectExport = {
      ...objectExport,
      ...params.columnFilter,
      start_row_index: 4,
      "custom_columns[B1]": "Kỳ",
      "custom_columns[B2]": "Chi Nhánh",
      "custom_columns[B3]": "Trạng thái hóa đơn",
      "custom_columns[C2]": buTenantHeaderInfo?.itemBU?.ten || "Tất cả",
      "custom_columns[C3]": "Điều chỉnh",
    };

    const filterMappings = {
      eq: "",
      gt: "Lớn hơn ngày ",
      gte: "Từ ngày ",
      lt: "Nhỏ hơn ngày ",
      lte: "Đến ngày ",
    };

    const columnKey = "custom_columns[C1]";
    let combinedFilters = "";

    const getCurrentDate = () => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0"); // Ensures two digits
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = now.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Helper function to convert date format
    const formatDate = dateString => {
      const [year, month, day] = dateString.split("-");
      return `${day}-${month}-${year}`; // Convert to dd-mm-yyyy
    };

    // Helper function to check if a specific filter group exists
    const hasFilters = filterGroup => {
      return Object.keys(filterMappings).some(
        filterKey =>
          !!params.columnFilter?.[`filter[${filterGroup}][${filterKey}]`]
      );
    };

    // Check if root_nlap filters exist
    if (hasFilters("root_nlap")) {
      // Process root_nlap filters
      Object.keys(filterMappings).forEach(filterKey => {
        const filterPath = `filter[root_nlap][${filterKey}]`;
        if (params.columnFilter?.[filterPath]) {
          const formattedDate = formatDate(params.columnFilter[filterPath]);
          combinedFilters += filterMappings[filterKey] + formattedDate + ", ";
        }
      });
    } else {
      // Process child_nlap filters if root_nlap is not present
      Object.keys(filterMappings).forEach(filterKey => {
        const filterPath = `filter[child_nlap][${filterKey}]`;
        if (params.columnFilter?.[filterPath]) {
          const formattedDate = formatDate(params.columnFilter[filterPath]);
          combinedFilters += filterMappings[filterKey] + formattedDate + ", ";
        }
      });
    }

    // If combinedFilters has any value, trim the trailing comma and space, then update finalObjectExport
    finalObjectExport = {
      ...finalObjectExport,
      [columnKey]: combinedFilters?.trim()?.slice(0, -1) || getCurrentDate(), // Removes the last ", "
    };

    console.log(
      "🚀 ~ exportFormatData ~ finalObjectExport:",
      finalObjectExport
    );
    return finalObjectExport;
  };

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const getInitColumns = (loadDefaultFilter = false) => {
    const initColumns = [
      {
        dataField: "root_id",
        text: "Id",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "75px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "root_id",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => (
          <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
            {cellContent ? cellContent : "(Hóa đơn TT32)"}
          </div>
        ),
        headerStyle: {
          color: "red",
        },
      },
      {
        dataField: "root_khhdon",
        text: "Ký hiệu",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "100px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "root_khhdon",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => {
          if (cellContent) {
            return String(row?.root_khmshdon) + String(row?.root_khhdon);
          } else {
            return "";
          }
        },
        headerStyle: {
          color: "red",
        },
      },
      {
        dataField: "root_shdon",
        text: "Số hóa đơn",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "100px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "root_shdon",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => (
          <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
            {cellContent ? cellContent : "Chờ cấp số"}
          </div>
        ),
        headerStyle: {
          color: "red",
        },
      },
      {
        dataField: "root_is_pos",
        text: "Loại HĐ",
        headerStyle: {
          color: "red",
        },
        formatter: (cellContent, row) => {
          if (cellContent === false) {
            return (
              <div className="d-flex gap-1 mt-2">
                <Badge className={`font-size-12 badge-soft-info`} pill>
                  HĐ TT78
                </Badge>
              </div>
            );
          } else if (cellContent === true) {
            return (
              <div className="d-flex gap-1 mt-2">
                <Badge className={`font-size-12 badge-soft-success`} pill>
                  HĐ MTT
                </Badge>
              </div>
            );
          }
        },
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: {
            0: "HĐ TT78",
            1: "HĐ MTT",
          },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "root_is_pos",
            dataDefaultFilter
          ),
        }),
      },
      {
        dataField: "root_nlap",
        text: "Ngày lập",
        formatter: (cellContent, row) => tableFormateDate(cellContent),
        headerStyle: {
          color: "red",
        },
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
            defaultValue={getDefaultValueFilter(
              loadDefaultFilter,
              "root_nlap",
              dataDefaultFilter
            )}
          />
        ),
      },
      {
        dataField: "root_tgtttbso",
        text: "Giá trị hóa đơn",
        formatter: (cell, row) => {
          return numberWithCommas(cell);
        },
        headerStyle: {
          color: "red",
        },
      },
      {
        dataField: "action_1",
        text: "",
        formatter: (cellContent, row) => {
          if (row.root_id) {
            return (
              <div className="d-flex gap-2 justify-content-center">
                <i
                  onClick={() => {
                    showDetailById(
                      row.root_id,
                      row.root_khmshdon,
                      row.root_is_pos
                    );
                  }}
                  title="Chi tiết hóa đơn"
                  style={{ cursor: "pointer" }}
                  className="text-info bx bx-message-square-dots label-icon font-size-20"
                />
                <i
                  onClick={() => {
                    showPdfById(row.root_id);
                  }}
                  title="Bản hiển thị"
                  style={{ cursor: "pointer" }}
                  className="text-danger bx bxs-file-pdf label-icon font-size-20"
                />
              </div>
            );
          }
        },
      },
      {
        dataField: "child_id",
        text: "Id",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "75px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "child_id",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => (
          <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
            {cellContent ? cellContent : "(Hóa đơn TT32)"}
          </div>
        ),
        headerStyle: {
          color: "blue",
        },
      },
      {
        dataField: "child_khhdon",
        text: "Ký hiệu",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "100px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "child_khhdon",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => {
          if (cellContent) {
            return String(row?.child_khmshdon) + String(row?.child_khhdon);
          } else {
            return "";
          }
        },
        headerStyle: {
          color: "blue",
        },
      },
      {
        dataField: "child_shdon",
        text: "Số hóa đơn",
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "100px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "child_shdon",
            dataDefaultFilter
          ),
        }),
        formatter: (cellContent, row) => (
          <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
            {cellContent ? cellContent : "Chờ cấp số"}
          </div>
        ),
        headerStyle: {
          color: "blue",
        },
      },
      {
        dataField: "child_is_pos",
        text: "Loại HĐ",
        headerStyle: {
          color: "blue",
        },
        formatter: (cellContent, row) => {
          if (cellContent === false) {
            return (
              <div className="d-flex gap-1 mt-2">
                <Badge className={`font-size-12 badge-soft-info`} pill>
                  HĐ TT78
                </Badge>
              </div>
            );
          } else if (cellContent === true) {
            return (
              <div className="d-flex gap-1 mt-2">
                <Badge className={`font-size-12 badge-soft-success`} pill>
                  HĐ MTT
                </Badge>
              </div>
            );
          }
        },
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: {
            0: "HĐ TT78",
            1: "HĐ MTT",
          },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "child_is_pos",
            dataDefaultFilter
          ),
        }),
      },
      {
        dataField: "child_nlap",
        text: "Ngày lập",
        formatter: (cellContent, row) => tableFormateDate(cellContent),
        headerStyle: {
          color: "blue",
        },
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
            defaultValue={getDefaultValueFilter(
              loadDefaultFilter,
              "child_nlap",
              dataDefaultFilter
            )}
          />
        ),
      },
      {
        dataField: "child_tgtttbso",
        text: "Giá trị hóa đơn",
        formatter: (cell, row) => {
          return numberWithCommas(cell);
        },
        headerStyle: {
          color: "blue",
        },
      },
      // {
      //   dataField: "child_note",
      //   text: "Ghi chú",
      //   formatter: (cellContent, row) => (
      //     <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
      //       {cellContent}
      //     </div>
      //   ),
      //   headerStyle: {
      //     color: "blue",
      //   },
      // },
      {
        dataField: "action_2",
        text: "",
        formatter: (cellContent, row) => {
          if (row.child_id) {
            return (
              <div className="d-flex gap-2 justify-content-center">
                <i
                  onClick={() => {
                    showDetailById(
                      row.child_id,
                      row.child_khmshdon,
                      row.child_is_pos
                    );
                  }}
                  title="Chi tiết hóa đơn"
                  style={{ cursor: "pointer" }}
                  className="text-info bx bx-message-square-dots label-icon font-size-20"
                />
                <i
                  onClick={() => {
                    showPdfById(row.child_id);
                  }}
                  title="Bản hiển thị"
                  style={{ cursor: "pointer" }}
                  className="text-danger bx bxs-file-pdf label-icon font-size-20"
                />
              </div>
            );
          }
        },
      },
    ];
    return initColumns;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    resetDataFunc();
  };

  const resetFilterHandle = () => {
    // Reset colums
    const columns = getInitColumns(false);
    let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    setColumns(formatHiddenColumn(columnsVisibleInvoice, columns));
    // Reset filter call api
    params.columnFilter = {};
    delete params.keywords;
    resetDataFunc();
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    resetDataFunc();
  };

  const optionShowColumnHandel = (field, value) => {
    let indexTargetColumn = columns.findIndex(item => item.dataField === field);
    if (indexTargetColumn > -1) {
      // Get column with defaultValuefilter
      const columnsWithFilter = getInitColumns(true).find(
        item => item.dataField === field
      );
      columnsWithFilter.hidden = !value;
      // Set lại cho default fitler cho column ẩn/hiện hiện tại
      columns[indexTargetColumn] = columnsWithFilter;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const resetDataFunc = isLoadDefaultFilter => {
    // Load defaultFilter
    if (isLoadDefaultFilter) {
      params.columnFilter = {
        ...params.columnFilter,
        ...getDefaultQueryFilter(dataDefaultFilter),
      };
    }
    dispatch(getReportInvoiceList(params, TYPE_INVOICE.ADJUST));
  };

  const showDetailById = (id, khmshdon, isPos) => {
    //   getListInvoiceSymbol(row.ttchung_khmshdon);
    //   setDataConfirmAction({
    //     typeAdjust: row.adjust_mod,
    //   });
    setDataDetail({
      id: id,
    });
    switch (khmshdon) {
      case "1":
        setPageView(issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE);
        setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
        break;
      case "2":
        setPageView(issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE);
        setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
        break;
      default:
        break;
    }
    if (isPos) {
      toggleDetailPosModal();
    } else {
      toggleDetailModal();
    }
  };

  const CaptionElement = (
    <div
      style={{
        textAlign: "center",
        border: "2px solid #eff2f7",
        borderBottom: "none",
        fontSize: "20px",
        display: "flex",
      }}
    >
      <div
        style={{
          color: "red",
          width: "50%",
          padding: "0.5em",
          borderRight: "2px solid #eff2f7",
        }}
      >
        Hóa đơn bị điều chỉnh
      </div>
      <div style={{ color: "blue", width: "50%", padding: "0.5em" }}>
        Hóa đơn điều chỉnh
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách hóa đơn điều chỉnh</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách hóa đơn điều chỉnh" + ` (${totalCount})`}
          />
          <Row>
            {/* Detail Modal */}
            <DetailInvoice
              dataDetail={dataDetail}
              //   dataConfirmAction={dataConfirmAction}
              isOpenModal={detailModal}
              toggleModal={toggleDetailModal}
              showPdfById={showPdfById}
              mode={mode}
              pageView={pageView}
            />
            {/* Detail InvoicePos Modal */}
            <DetailInvoicePos
              dataDetail={dataDetail}
              //   dataConfirmAction={dataConfirmAction}
              isOpenModal={detailPosModal}
              toggleModal={toggleDetailPosModal}
              showPdfById={showPdfById}
              mode={mode}
              pageView={pageView}
            />
            {/* PDFViewModal */}
            <PDFViewModal
              isOpen={modalPdfView}
              dataViewDocument={dataViewDocument}
              toggle={togglePdfViewModal}
            ></PDFViewModal>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      resetFilterHandle={resetFilterHandle}
                      caption={CaptionElement}
                      screenFilterCode={SCREEN_FILTER_CODE.INVOICE_ADJUST}
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      listMultipleRowAction={listMultipleRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    ></RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListAdjust;
